module.exports = __webpack_public_path__ + "static/media/benin.2d18d7b8.jpg";